<template>
  <div
    v-if="loading"
    class="w-12 h-12 rounded-full bg-slate-200 animate-pulse border-2 border-white shadow-sm z-[1]"
  ></div>

  <div v-else class="flex items-center gap-2 z-[1]">
    <span
      v-if="statusLabel && !isActive"
      class="px-2 py-1 rounded-md border text-sm font-medium text-textPrimary"
      :class="{
        'bg-[#FCE9EA] border-negative': status === ExceptionSummaryStatus.APPROVED,
        'bg-[#FEF3E7] border-alert': status === ExceptionSummaryStatus.IN_PROGRESS,
        'bg-[#FEF9E7] border-warning': status === ExceptionSummaryStatus.IN_REVIEW
      }"
    >
      {{ statusLabel }}
    </span>

    <div
      @click="emit('click')"
      class="w-12 h-12 flex items-center justify-center rounded-full border-2 transition-all cursor-pointer bg-white"
      :class="{
        'border-negative bg-[#FCE9EA]': status === ExceptionSummaryStatus.APPROVED,
        'border-alert bg-[#FEF3E7]': status === ExceptionSummaryStatus.IN_PROGRESS,
        'border-warning bg-[#FEF9E7]': status === ExceptionSummaryStatus.IN_REVIEW,
        'border-primary30': !status
      }"
      @mouseenter="hover = true"
      @mouseleave="hover = false"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 transition-colors" viewBox="0 0 24 24">
        <path :d="hover && status === null ? mdiLockOpenVariant : iconPath" :fill="iconFillColor" />
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { mdiLock, mdiLockOpenVariant } from '@mdi/js'
import { ExceptionSummaryStatus } from '@/Network/Types/Responses/StationResponses'

const props = withDefaults(
  defineProps<{
    status: ExceptionSummaryStatus | null
    isActive?: boolean
    loading?: boolean
  }>(),
  {
    loading: false
  }
)

const emit = defineEmits<{
  (e: 'click'): void
}>()

const hover = ref(false)

const labelMap: Record<string, string> = {
  APPROVED: 'Aprovado',
  IN_PROGRESS: 'Em Andamento',
  IN_REVIEW: 'Em revisão'
}

const statusLabel = computed(() => {
  return props.status ? labelMap[props.status] : null
})

const iconPath = computed(() =>
  [null, ExceptionSummaryStatus.IN_PROGRESS].includes(props.status) ? mdiLock : mdiLockOpenVariant
)

const iconFillColor = computed(() => {
  if (props.status === null) {
    return hover.value ? '#235E6C' : '#3CA2B9'
  }

  switch (props.status) {
    case ExceptionSummaryStatus.APPROVED:
      return hover.value ? '#DA1E28' : '#DA1E28A3'
    case ExceptionSummaryStatus.IN_PROGRESS:
      return hover.value ? '#F18F1B' : '#F18F1BA3'
    case ExceptionSummaryStatus.IN_REVIEW:
      return hover.value ? '#F1C21B' : '#F1C21BA3'
    default:
      return '#FFFFFF' // Cor de fallback
  }
})
</script>
